import { cn } from "@babybjorn/ui";

import type { FC } from "react";
import * as s from "./Indicator.module.scss";

type IndicatorProps = {
	amountOfImages: number;
	activeIndex: number;
};

const Indicator: FC<IndicatorProps> = ({ amountOfImages, activeIndex }) => {
	return (
		<div className={s.indicator}>
			{Array.from({ length: amountOfImages })
				.fill(null)
				.map((_, index) => (
					<span
						key={index}
						className={cn(s.flurp, { [s.active]: index === activeIndex })}
					/>
				))}
		</div>
	);
};

export default Indicator;
